export const handleFirestoreError = (error: unknown): string => {
  if (error) {
    switch (error) {
      case 'critical-error':
        return 'The requested Firestore collection or document does not exist.';
      case 'permission-denied':
        return 'You do not have permission to access this Firestore resource.';
      case 'unavailable':
        return 'Firestore service is currently unavailable. Please try again later.';
        // Add more cases as needed for other Firestore error codes
      default:
        return 'An unknown Firestore error occurred';
    }
  }
  return 'An unexpected error occurred.';
};
